import abb from './abb.json';
import copadata from './copadata.json';
import omterra from './omterra.json';
import straton from './straton.json';

const OEM_PROFILES = Object.freeze({
  abb,
  copadata,
  omterra,
  straton,
});

export default OEM_PROFILES;
